import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { PlataformaChatbotsComponent } from './plataforma-chatbots.component';
import { CabecalhoEsquerdaModule } from '../../components/cabecalho/cabecalho-esquerda/cabecalho-esquerda.module';
import { BeneficioDireitaModule } from '../../components/beneficio/beneficio-direita/beneficio-direita.module';
import { BeneficioEsquerdaModule } from '../../components/beneficio/beneficio-esquerda/beneficio-esquerda.module';
import { SolucoesModule } from '../../components/solucoes/solucoes.module';

@NgModule({
  declarations: [
    PlataformaChatbotsComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoEsquerdaModule,
    BeneficioEsquerdaModule,
    BeneficioDireitaModule,
    SolucoesModule
  ],
  exports: [
    PlataformaChatbotsComponent
  ]
})

export class PlataformaChatbotsModule { }
